import Icon from '../../../components/AppIcon';
import React from 'react';

const MissionValuesSection = () => {
  const values = [
    {
      id: 1,
      title: "Unwavering Advocacy",
      description: "We stand firmly beside our clients, fighting tirelessly for their rights and interests with passionate dedication and strategic precision.",
      icon: "Shield",
      color: "primary"
    },
    {
      id: 2,
      title: "Intellectual Rigor",
      description: "Our approach combines deep legal scholarship with innovative thinking, ensuring comprehensive analysis and creative solutions for complex challenges.",
      icon: "Brain",
      color: "accent"
    },
    {
      id: 3,
      title: "Client-Centered Service",
      description: "Every decision we make prioritizes our clients' best interests, delivering personalized attention and transparent communication throughout the legal process.",
      icon: "Users",
      color: "primary"
    },
    {
      id: 4,
      title: "Ethical Excellence",
      description: "We maintain the highest standards of professional conduct, building trust through integrity, honesty, and unwavering commitment to ethical practice.",
      icon: "Scale",
      color: "accent"
    }
  ];

  return (
		<section className='py-20 bg-surface'>
			<div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
				{/* Mission Statement */}
				<div className='text-center mb-16'>
					<h2 className='font-playfair font-bold text-3xl md:text-4xl lg:text-5xl text-primary mb-8'>
						Empowering Justice Through
						<span className='block text-accent'>Legal Excellence</span>
					</h2>

					<p className='font-source text-lg md:text-xl text-text-secondary max-w-4xl mx-auto leading-relaxed'>
						At Fepa, we believe that exceptional legal representation should be accessible to all
						who need it. Our mission is to provide sophisticated legal counsel that combines
						traditional values with innovative approaches, ensuring that every client receives the
						dedicated advocacy they deserve.
					</p>
				</div>

				{/* Core Values Grid */}
				<div className='grid md:grid-cols-2 gap-8'>
					{values?.map((value, index) => (
						<div
							key={value?.id}
							className={`group relative bg-white rounded-2xl p-8 shadow-premium hover:shadow-xl transition-all duration-300 hover:-translate-y-2 ${
								index % 2 === 0 ? 'md:translate-y-8' : ''
							}`}
						>
							{/* Header with Icon */}
							<div className='flex items-start space-x-4 mb-6'>
								<div
									className={`w-16 h-16 rounded-xl flex items-center justify-center transition-all duration-300 group-hover:scale-110 ${
										value?.color === 'primary'
											? 'bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white'
											: 'bg-accent/10 text-accent group-hover:bg-accent group-hover:text-primary'
									}`}
								>
									<Icon name={value?.icon} size={28} strokeWidth={2} />
								</div>

								<div className='flex-1'>
									<h3 className='font-playfair font-bold text-xl md:text-2xl text-primary mb-2 group-hover:text-primary transition-colors duration-300'>
										{value?.title}
									</h3>
									<div
										className={`w-12 h-1 rounded-full transition-all duration-300 group-hover:w-20 ${
											value?.color === 'primary' ? 'bg-primary' : 'bg-accent'
										}`}
									></div>
								</div>
							</div>

							{/* Description */}
							<p className='font-source text-text-secondary leading-relaxed'>
								{value?.description}
							</p>

							{/* Decorative Element */}
							<div
								className={`absolute top-4 right-4 w-20 h-20 rounded-full opacity-5 transition-opacity duration-300 group-hover:opacity-10 ${
									value?.color === 'primary' ? 'bg-primary' : 'bg-accent'
								}`}
							></div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default MissionValuesSection;